import { Drawer, Navbar, Sidebar } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import LogoComponent from '../components/LogoComponent';
import { FiMenu, FiX } from 'react-icons/fi';
import DarkModeToggle from '../components/DarkModeToggle';
import TruncatedText from '../components/TruncatedText';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoIosArrowDown } from "react-icons/io";
import StyledText from '../components/styledText';
import YouTube from 'react-youtube';
import { toast } from 'react-toastify';
import { logo, name, serverURL, websiteURL } from '../constants';
import axios from 'axios';
import { FaCheck } from "react-icons/fa";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import html2pdf from 'html2pdf.js';
import ShareOnSocial from 'react-share-on-social';
import ChatWidget from '../components/chatWidget';
import NotesWidget from '../components/notesWidget';
import { AiFillHome } from "react-icons/ai";
import { HiDownload } from "react-icons/hi";
import { RiShareFill } from "react-icons/ri";
import { buildCourseUrl } from '../utils/slug';

const Course = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [key, setkey] = useState('');
    const { state } = useLocation();
    const { mainTopic, type, courseId, end, pass, lang } = state || {};
    const jsonData = JSON.parse(sessionStorage.getItem('jsonData'));
    const storedTheme = sessionStorage.getItem('darkMode');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selected, setSelected] = useState('');
    const [theory, setTheory] = useState('');
    const [media, setMedia] = useState('');
    const [percentage, setPercentage] = useState(0);
    const [isComplete, setIsCompleted] = useState(false);
    const navigate = useNavigate();
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');

    async function redirectExam() {
        const id = toast.loading("Please wait...")
        const mainTopicExam = jsonData[mainTopic.toLowerCase()];
        let subtopicsString = '';
        mainTopicExam.map((topicTemp) => {
            let titleOfSubTopic = topicTemp.title;
            subtopicsString = subtopicsString + ' , ' + titleOfSubTopic;
        });

        const postURL = serverURL + '/api/aiexam';
        const response = await axios.post(postURL, { courseId, mainTopic, subtopicsString, lang });
        if (response.data.success) {
            const element = document.documentElement; // or you can use a specific container if you want
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) { // Firefox
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { // IE/Edge
                element.msRequestFullscreen();
            } else {
                console.error('Full-screen mode is not supported by this browser.');
            }
            let questions = JSON.parse(response.data.message);
            navigate('/exam', { state: { topic: mainTopic, courseId: courseId, questions: questions } });
            toast.update(id, { render: "Starting Quiz", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        } else {
            toast.update(id, { render: "Internal Server Error", type: "error", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        }

    }

    async function htmlDownload() {
        const id = toast.loading("Please wait exporting...")
        // Generate the combined HTML content
        const combinedHtml = await getCombinedHtml(mainTopic, jsonData[mainTopic.toLowerCase()]);

        // Create a temporary div element
        const tempDiv = document.createElement('div');
        tempDiv.style.width = '100%';  // Ensure div is 100% width
        tempDiv.style.height = '100%';  // Ensure div is 100% height
        tempDiv.innerHTML = combinedHtml;
        document.body.appendChild(tempDiv);

        // Create the PDF options
        const options = {
            filename: `${mainTopic}.pdf`,
            image: { type: 'jpeg', quality: 1 },
            margin: [15, 15, 15, 15],
            pagebreak: { mode: ["avoid-all", "css", "legacy"] },
            html2canvas: {
                scale: 2,
                logging: false,
                scrollX: 0,
                scrollY: 0,
                useCORS: true
            },
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
        };

        // Generate the PDF
        html2pdf().from(tempDiv).set(options).save().then(() => {
            // Save the PDF
            document.body.removeChild(tempDiv);
            toast.update(id, { render: "Done!", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        });
    }


    async function getCombinedHtml(mainTopic, topics) {


        async function toDataUrl(url) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();

                xhr.onload = function () {
                    const reader = new FileReader();
                    reader.onloadend = function () {
                        resolve(reader.result);
                    };
                    reader.readAsDataURL(xhr.response);
                };

                xhr.onerror = function () {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText,
                    });
                };

                xhr.open("GET", url);
                xhr.responseType = "blob";
                xhr.send();
            }).catch(error => {
                console.error(`Failed to fetch image at ${url}:`, error);
                return ''; // Fallback or placeholder
            });
        }

        const topicsHtml = topics.map(topic => `
            <h3 style="font-size: 18pt; font-weight: bold; margin: 0; margin-top: 15px;">${topic.title}</h3>
            ${topic.subtopics.map(subtopic => `
                <p style="font-size: 16pt; margin-top: 10px;">${subtopic.title}</p>
            `).join('')}
        `).join('');

        const theoryPromises = topics.map(async topic => {
            const subtopicPromises = topic.subtopics.map(async (subtopic, index, array) => {
                const imageUrl = type === 'text & image course' ? await toDataUrl(subtopic.image) : ``;
                console.log(imageUrl);
                return `
                <div>
                    <p style="font-size: 16pt; margin-top: 20px; font-weight: bold;">
                        ${subtopic.title}
                    </p>
                    <div style="font-size: 12pt; margin-top: 15px;">
                        ${subtopic.done
                        ? `
                                ${type === 'text & image course'
                            ? (imageUrl ? `<img style="margin-top: 10px;" src="${imageUrl}" alt="${subtopic.title} image">` : `<a style="color: #0000FF;" href="${subtopic.image}" target="_blank">View example image</a>`)
                            : `<a style="color: #0000FF;" href="https://www.youtube.com/watch?v=${subtopic.youtube}" target="_blank" rel="noopener noreferrer">Watch the YouTube video on ${subtopic.title}</a>`
                        }
                                <div style="margin-top: 10px;">${subtopic.theory}</div>
                            `
                        : `<div style="margin-top: 10px;">Please visit ${subtopic.title} topic to export as PDF. Only topics that are completed will be added to the PDF.</div>`
                    }
                    </div>
                </div>
            `;
            });
            const subtopicHtml = await Promise.all(subtopicPromises);
            return `
                <div style="margin-top: 30px;">
                    <h3 style="font-size: 18pt; text-align: center; font-weight: bold; margin: 0;">
                        ${topic.title}
                    </h3>
                    ${subtopicHtml.join('')}
                </div>
            `;
        });
        const theoryHtml = await Promise.all(theoryPromises);

        return `
        <div class="html2pdf__page-break" 
             style="display: flex; align-items: center; justify-content: center; text-align: center; margin: 0 auto; max-width: 100%; height: 11in;">
            <h1 style="font-size: 30pt; font-weight: bold; margin: 0;">
                ${mainTopic}
            </h1>
        </div>
        <div class="html2pdf__page-break" style="text-align: start; margin-top: 30px; margin-right: 16px; margin-left: 16px;">
            <h2 style="font-size: 24pt; font-weight: bold; margin: 0;">Index</h2>
            <br>
            <hr>
            ${topicsHtml}
        </div>
        <div style="text-align: start; margin-right: 16px; margin-left: 16px;">
            ${theoryHtml.join('')}
        </div>
        `;
    }



    const CountDoneTopics = () => {
        let doneCount = 0;
        let totalTopics = 0;

        jsonData[mainTopic.toLowerCase()].forEach((topic) => {

            topic.subtopics.forEach((subtopic) => {

                if (subtopic.done) {
                    doneCount++;
                }
                totalTopics++;
            });
        });
        totalTopics = totalTopics + 1;
        if(pass){
            totalTopics = totalTopics - 1;
        }
        const completionPercentage = Math.round((doneCount / totalTopics) * 100);
        setPercentage(completionPercentage);
        if (completionPercentage >= '100') {
            setIsCompleted(true);
        }
    }

    const opts = {
        height: '390',
        width: '640',
    };

    const optsMobile = {
        height: '250px',
        width: '100%',
    };

    async function finish() {
        if (sessionStorage.getItem('first') === 'true') {
            if (!end) {
                const today = new Date();
                const formattedDate = today.toLocaleDateString('en-GB');
                navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
            } else {
                navigate('/certificate', { state: { courseTitle: mainTopic, end: end } });
            }

        } else {
            const dataToSend = {
                courseId: courseId
            };
            try {
                const postURL = serverURL + '/api/finish';
                const response = await axios.post(postURL, dataToSend);
                if (response.data.success) {
                    const today = new Date();
                    const formattedDate = today.toLocaleDateString('en-GB');
                    sessionStorage.setItem('first', 'true');
                    sendEmail(formattedDate);
                } else {
                    finish()
                }
            } catch (error) {
                finish()
            }
        }
    }

    async function sendEmail(formattedDate) {
        const userName = sessionStorage.getItem('mName');
        const email = sessionStorage.getItem('email');
        const html = `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="initial-scale=1.0">
            <title>Certificate of Completion</title>
            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;900&display=swap">
            <style>
            body {
                font-family: 'Roboto', sans-serif;
                text-align: center;
                background-color: #fff;
                margin: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
            }
        
            .certificate {
                border: 10px solid #000;
                max-width: 600px;
                margin: 20px auto;
                padding: 50px;
                background-color: #fff;
                position: relative;
                color: #000;
                text-align: center;
            }
        
            h1 {
                font-weight: 900;
                font-size: 24px;
                margin-bottom: 10px;
            }
        
            h4 {
                font-weight: 900;
                text-align: center;
                font-size: 20px;
            }
        
            h2 {
                font-weight: 700;
                font-size: 18px;
                margin-top: 10px;
                margin-bottom: 5px;
                text-decoration: underline;
            }
        
            h3 {
                font-weight: 700;
                text-decoration: underline;
                font-size: 16px;
                margin-top: 5px;
                margin-bottom: 10px;
            }
        
            p {
                font-weight: 400;
                line-height: 1.5;
            }
        
            img {
                width: 40px;
                height: 40px;
                margin-right: 10px;
                text-align: center;
                align-self: center;
            }
            </style>
        </head>
        <body>
        
        <div class="certificate">
        <h1>Certificate of Completion 🥇</h1>
        <p>This is to certify that</p>
        <h2>${userName}</h2>
        <p>has successfully completed the course on</p>
        <h3>${mainTopic}</h3>
        <p>on ${formattedDate}.</p>
    
        <div class="signature">
            <img src=${logo}>
            <h4>${name}</h4>
        </div>
    </div>
        
        </body>
        </html>`;

        try {
            const postURL = serverURL + '/api/sendcertificate';
            await axios.post(postURL, { html, email }).then(res => {
                navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
            }).catch(error => {
                navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
            });

        } catch (error) {
            navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
        }

    }

    useEffect(() => {
        loadMessages()
        const CountDoneTopics = () => {
            let doneCount = 0;
            let totalTopics = 0;

            jsonData[mainTopic.toLowerCase()].forEach((topic) => {

                topic.subtopics.forEach((subtopic) => {

                    if (subtopic.done) {
                        doneCount++;
                    }
                    totalTopics++;
                });
            });
            totalTopics = totalTopics + 1;
            if(pass){
                doneCount = doneCount + 1;
            }
            const completionPercentage = Math.round((doneCount / totalTopics) * 100);
            setPercentage(completionPercentage);
            if (completionPercentage >= '100') {
                setIsCompleted(true);
            }
        }

        if (!mainTopic) {
            navigate("/create");
        } else {
            if (percentage >= '100') {
                setIsCompleted(true);
            }

            const mainTopicData = jsonData[mainTopic.toLowerCase()][0];
            const firstSubtopic = mainTopicData.subtopics[0];
            firstSubtopic.done = true
            setSelected(firstSubtopic.title)
            setTheory(firstSubtopic.theory);

            if (type === 'video & text course') {
                setMedia(firstSubtopic.youtube);
            } else {
                setMedia(firstSubtopic.image)

            }
            sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
            CountDoneTopics();

        }

    }, []);

    const handleSelect = (topics, sub) => {

        const mTopic = jsonData[mainTopic.toLowerCase()].find(topic => topic.title === topics);
        const mSubTopic = mTopic?.subtopics.find(subtopic => subtopic.title === sub);

        if (mSubTopic.theory === '' || mSubTopic.theory === undefined || mSubTopic.theory === null) {
            if (type === 'video & text course') {

                const query = `${mSubTopic.title} ${mainTopic} in english`;
                const id = toast.loading("Please wait...")
                sendVideo(query, topics, sub, id, mSubTopic.title);

            } else {

                const prompt = `Strictly in ${lang}, Explain me about this subtopic of ${mainTopic} with examples :- ${mSubTopic.title}. Please Strictly Don't Give Additional Resources And Images.`;
                const promptImage = `Example of ${mSubTopic.title} in ${mainTopic}`;
                const id = toast.loading("Please wait...")
                sendPrompt(prompt, promptImage, topics, sub, id);

            }
        } else {
            setSelected(mSubTopic.title)

            setTheory(mSubTopic.theory)
            if (type === 'video & text course') {
                setMedia(mSubTopic.youtube);
            } else {
                setMedia(mSubTopic.image)
            }
        }

    };

    async function sendPrompt(prompt, promptImage, topics, sub, id, attempt = 0) {
        if (attempt >= 2) {
            toast.update(id, { render: 'Failed to generate lesson. Please try again.', type: 'error', isLoading: false, autoClose: 4000, hideProgressBar: false, closeOnClick: true });
            return;
        }
        const dataToSend = { prompt: prompt };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            if (!generatedText) {
                return sendPrompt(prompt, promptImage, topics, sub, id, attempt + 1);
            }
            sendImage(generatedText, promptImage, topics, sub, id);
        } catch (error) {
            sendPrompt(prompt, promptImage, topics, sub, id, attempt + 1);
        }
    }

    async function sendImage(parsedJson, promptImage, topics, sub, id, attempt = 0) {
        if (attempt >= 2) {
            // Continue without an image rather than blocking the lesson
            sendData(`https://placehold.co/1200x600/f3f4f6/9ca3af?text=${encodeURIComponent(promptImage.slice(0, 30))}`, parsedJson, topics, sub, id);
            return;
        }
        const dataToSend = { prompt: promptImage };
        try {
            const postURL = serverURL + '/api/image';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.url;
            sendData(generatedText, parsedJson, topics, sub, id);
        } catch (error) {
            sendImage(parsedJson, promptImage, topics, sub, id, attempt + 1);
        }
    }

    async function sendData(image, theory, topics, sub, id) {

        const mTopic = jsonData[mainTopic.toLowerCase()].find(topic => topic.title === topics);
        const mSubTopic = mTopic?.subtopics.find(subtopic => subtopic.title === sub);
        mSubTopic.theory = theory
        mSubTopic.image = image;
        setSelected(mSubTopic.title)

        toast.update(id, { render: "Done!", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        setTheory(theory)
        if (type === 'video & text course') {
            setMedia(mSubTopic.youtube);
        } else {
            setMedia(image)
        }
        mSubTopic.done = true;
        updateCourse();
    }

    async function sendDataVideo(image, theory, topics, sub, id) {

        const mTopic = jsonData[mainTopic.toLowerCase()].find(topic => topic.title === topics);
        const mSubTopic = mTopic?.subtopics.find(subtopic => subtopic.title === sub);
        mSubTopic.theory = theory
        mSubTopic.youtube = image;
        setSelected(mSubTopic.title)

        toast.update(id, { render: "Done!", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        setTheory(theory)
        if (type === 'video & text course') {
            setMedia(image);
        } else {
            setMedia(mSubTopic.image)
        }
        mSubTopic.done = true;
        updateCourse();

    }

    async function updateCourse() {
        CountDoneTopics();
        sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
        const dataToSend = {
            content: JSON.stringify(jsonData),
            courseId: courseId
        };
        try {
            const postURL = serverURL + '/api/update';
            await axios.post(postURL, dataToSend);
        } catch (error) {
            //updateCourse()
        }
    }

    async function sendVideo(query, mTopic, mSubTopic, id, subtop, attempt = 0) {
        if (attempt >= 2) {
            toast.update(id, { render: 'Failed to load video. Please try again.', type: 'error', isLoading: false, autoClose: 4000, hideProgressBar: false, closeOnClick: true });
            return;
        }
        const dataToSend = { prompt: query };
        try {
            const postURL = serverURL + '/api/yt';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.url;
            sendTranscript(generatedText, mTopic, mSubTopic, id, subtop);
        } catch (error) {
            sendVideo(query, mTopic, mSubTopic, id, subtop, attempt + 1);
        }
    }

    async function sendTranscript(url, mTopic, mSubTopic, id, subtop) {
        const fallbackPrompt = `Strictly in ${lang}, Explain me about this subtopic of ${mainTopic} with examples :- ${subtop}. Please Strictly Don't Give Additional Resources And Images.`;
        const dataToSend = { prompt: url };
        try {
            const postURL = serverURL + '/api/transcript';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.url;
            if (!Array.isArray(generatedText) || generatedText.length === 0) {
                sendSummery(fallbackPrompt, url, mTopic, mSubTopic, id);
                return;
            }
            const concatenatedText = generatedText.map(item => item.text).join(' ');
            const prompt = `Strictly in ${lang}, Summarize this theory in a teaching way :- ${concatenatedText}.`;
            sendSummery(prompt, url, mTopic, mSubTopic, id);
        } catch (error) {
            sendSummery(fallbackPrompt, url, mTopic, mSubTopic, id);
        }
    }

    async function sendSummery(prompt, url, mTopic, mSubTopic, id, attempt = 0) {
        if (attempt >= 2) {
            toast.update(id, { render: 'Failed to generate lesson. Please try again.', type: 'error', isLoading: false, autoClose: 4000, hideProgressBar: false, closeOnClick: true });
            return;
        }
        const dataToSend = { prompt: prompt };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            if (!generatedText) {
                return sendSummery(prompt, url, mTopic, mSubTopic, id, attempt + 1);
            }
            sendDataVideo(url, generatedText, mTopic, mSubTopic, id);
        } catch (error) {
            sendSummery(prompt, url, mTopic, mSubTopic, id, attempt + 1);
        }
    }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleOpenClose = (keys) => {
        setIsOpen(!isOpen)
        setkey(keys);
    };

    const defaultMessage = `<p>Hey there! I'm your AI teacher. If you have any questions about your ${mainTopic} course, whether it's about videos, images, or theory, just ask me. I'm here to clear your doubts.</p>`;
    const defaultPrompt = `I have a doubt about this topic :- ${mainTopic}. Please clarify my doubt in very short :- `;

    const loadMessages = async () => {
        try {
            const jsonValue = sessionStorage.getItem(mainTopic);
            if (jsonValue !== null) {
                setMessages(JSON.parse(jsonValue));
            } else {
                const newMessages = [...messages, { text: defaultMessage, sender: 'bot' }];
                setMessages(newMessages);
                await storeLocal(newMessages);
            }
        } catch (error) {
            loadMessages();
        }
    };

    const sendMessage = async () => {
        if (newMessage.trim() === '') return;

        const userMessage = { text: newMessage, sender: 'user' };
        const updatedMessages = [...messages, userMessage];
        setMessages(updatedMessages);
        await storeLocal(updatedMessages);
        setNewMessage('');

        let mainPrompt = defaultPrompt + newMessage;
        const dataToSend = { prompt: mainPrompt };
        const url = serverURL + '/api/chat';

        try {
            const response = await axios.post(url, dataToSend);

            if (response.data.success === false) {
                sendMessage();
            } else {
                const botMessage = { text: response.data.text, sender: 'bot' };
                const updatedMessagesWithBot = [...updatedMessages, botMessage];
                setMessages(updatedMessagesWithBot);
                await storeLocal(updatedMessagesWithBot);
            }
        } catch (error) {

        }
    };

    async function storeLocal(messages) {
        try {
            sessionStorage.setItem(mainTopic, JSON.stringify(messages));
        } catch (error) {
            sessionStorage.setItem(mainTopic, JSON.stringify(messages));
        }
    }

    function redirectHome() {
        navigate("/home");
    }

    const style = {
        "root": {
            "base": "h-full",
            "collapsed": {
                "on": "w-16",
                "off": "w-64 max-w-64 min-w-64"
            },
            "inner": "no-scrollbar h-full overflow-y-auto overflow-x-hidden rounded-none border-black dark:border-white md:border-r  bg-white py-4 px-3 dark:bg-black"
        }
    }

    const renderTopicsAndSubtopics = (topics) => {
        try {
            return (
                <div className='space-y-1'>
                    {topics.map((topic, idx) => {
                        const expanded = isOpen && key === topic.title;
                        const doneCount = topic.subtopics.filter(s => s.done).length;
                        const total = topic.subtopics.length;
                        return (
                            <div key={topic.title} className='border-b border-gray-100 dark:border-gray-900 last:border-0 pb-1'>
                                <button
                                    onClick={() => handleOpenClose(topic.title)}
                                    type="button"
                                    className='w-full flex items-center justify-between text-left px-3 py-2.5 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors'
                                >
                                    <div className='flex items-center gap-2 flex-1 min-w-0'>
                                        <span className='flex-shrink-0 w-6 h-6 rounded-md bg-black dark:bg-white text-white dark:text-black text-xs font-bold flex items-center justify-center'>{idx + 1}</span>
                                        <span className='text-sm font-bold text-black dark:text-white truncate'>{topic.title}</span>
                                    </div>
                                    <div className='flex items-center gap-1.5 flex-shrink-0'>
                                        <span className='text-[10px] text-gray-400 font-medium'>{doneCount}/{total}</span>
                                        <IoIosArrowDown className={`h-3 w-3 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`} />
                                    </div>
                                </button>
                                {expanded && (
                                    <div className='mt-1 ml-4 pl-3 border-l-2 border-gray-100 dark:border-gray-800 space-y-0.5'>
                                        {topic.subtopics.map((subtopic) => {
                                            const active = selected === subtopic.title;
                                            return (
                                                <button
                                                    key={subtopic.title}
                                                    onClick={() => handleSelect(topic.title, subtopic.title)}
                                                    className={`w-full flex items-center gap-2 px-2 py-2 rounded-md text-left transition-colors ${active ? 'bg-black dark:bg-white text-white dark:text-black' : 'hover:bg-gray-50 dark:hover:bg-gray-900 text-black dark:text-white'}`}
                                                >
                                                    <span className={`flex-shrink-0 w-4 h-4 rounded-full flex items-center justify-center text-[9px] ${subtopic.done ? 'bg-green-500 text-white' : active ? 'bg-white/20' : 'border border-gray-300 dark:border-gray-700'}`}>
                                                        {subtopic.done ? <FaCheck size={8} /> : null}
                                                    </span>
                                                    <span className='text-xs font-medium flex-1 truncate'>{subtopic.title}</span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            );
        } catch (error) {
            return (
                <div>
                    {topics.map((topic) => (
                        <Sidebar.ItemGroup key={topic.Title}>
                            <div className="relative inline-block text-left " >
                                <button
                                    onClick={() => handleOpenClose(topic.Title)}
                                    type="button"
                                    className="inline-flex text-start text-base font-bold  text-black dark:text-white"
                                >
                                    {topic.Title}
                                    <IoIosArrowDown className="-mr-1 ml-2 h-3 w-3 mt-2" />
                                </button>

                                {isOpen && key === topic.Title && (
                                    <div className="origin-top-right mt-2 pr-4">
                                        <div
                                            className="py-1"
                                            role="menu"
                                            aria-orientation="vertical"
                                            aria-labelledby="options-menu"
                                        >
                                            {topic.Subtopics.map((subtopic) => (
                                                <p
                                                    key={subtopic.Title}
                                                    onClick={() => handleSelect(topic.Title, subtopic.Title)}
                                                    className="flex py-2 flex-row text-sm items-center font-normal text-black dark:text-white  text-start"
                                                    role="menuitem"
                                                >
                                                    {subtopic.Title}
                                                    {subtopic.done === true ? <FaCheck className='ml-2' size={12} /> : <></>}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Sidebar.ItemGroup>
                    ))}
                </div>
            );
        }
    };

    return (
        <>
            {!mainTopic ? <></>
                :
                <div>
                    <div className="flex bg-white dark:bg-black md:hidden pb-10 overflow-y-auto">
                        <div className={`fixed inset-0 bg-black opacity-50 z-50 ${isSidebarOpen ? 'block' : 'hidden'}`} onClick={toggleSidebar}></div>
                        <div className="flex-1 flex flex-col overflow-hidden">

                            <div>
                                <Navbar fluid className='py-3 dark:bg-black bg-white border-black dark:border-white md:border-b'>
                                    <Navbar.Brand className='ml-1'>

                                        {isComplete ?
                                            <p onClick={finish} className='mr-3 underline text-black dark:text-white font-normal'>Certificate</p>
                                            :
                                            <div className='w-7 h-7 mr-3'>
                                                <CircularProgressbar
                                                    value={percentage}
                                                    text={`${percentage}%`}
                                                    styles={buildStyles({
                                                        rotation: 0.25,
                                                        strokeLinecap: 'butt',
                                                        textSize: '20px',
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: storedTheme === "true" ? '#fff' : '#000',
                                                        textColor: storedTheme === "true" ? '#fff' : '#000',
                                                        trailColor: storedTheme === "true" ? 'grey' : '#d6d6d6',
                                                    })}
                                                />
                                            </div>
                                        }

                                        <TruncatedText text={mainTopic} len={1} />
                                    </Navbar.Brand>
                                    <div className='flex md:hidden justify-center items-center'>
                                        <div className='mx-2' onClick={redirectHome}><AiFillHome size={20} color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'} /></div>
                                        <div className='mx-2' onClick={htmlDownload}><HiDownload size={20} color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'} /></div>
                                        <div>
                                            <ShareOnSocial
                                                textToShare={sessionStorage.getItem('mName') + " shared you course on " + mainTopic}
                                                link={websiteURL + buildCourseUrl(mainTopic, courseId)}
                                                linkTitle={sessionStorage.getItem('mName') + " shared you course on " + mainTopic}
                                                linkMetaDesc={sessionStorage.getItem('mName') + " shared you course on " + mainTopic}
                                                linkFavicon={logo}
                                                noReferer
                                            >

                                                <div className='mx-2'><RiShareFill size={20} color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'} /></div>

                                            </ShareOnSocial>
                                        </div>
                                        <DarkModeToggle className='inline-flex items-center md:hidden' />
                                        {isSidebarOpen ? (
                                            <FiX
                                                onClick={toggleSidebar}
                                                className='mx-2'
                                                size={20}
                                                color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'}
                                            />
                                        ) : (
                                            <FiMenu
                                                onClick={toggleSidebar}
                                                className='mx-2'
                                                size={20}
                                                color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'}
                                            />
                                        )}
                                    </div>
                                    <Navbar.Collapse>
                                        <div className='hidden md:flex justify-center items-center mb-2 mt-2'>
                                            <DarkModeToggle />
                                        </div>
                                    </Navbar.Collapse>
                                </Navbar>

                            </div>

                            <Sidebar
                                aria-label="Default sidebar example"
                                theme={style}
                                className={`md:border-r md:border-black md:dark:border-white dark:bg-black fixed inset-y-0 left-0 w-64  bg-white z-50 overflow-y-auto transition-transform transform lg:translate-x-0 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
                            >
                                <LogoComponent isDarkMode={storedTheme} />
                                <div className='mt-4 mb-3 px-3'>
                                    <p className='text-[10px] font-bold uppercase tracking-wider text-gray-400 mb-2'>Course Progress</p>
                                    <div className='h-1.5 w-full bg-gray-100 dark:bg-gray-900 rounded-full overflow-hidden'>
                                        <div className='h-full bg-gradient-to-r from-green-400 to-green-600 transition-all duration-500' style={{ width: `${percentage}%` }} />
                                    </div>
                                    <p className='text-xs font-bold text-black dark:text-white mt-1.5'>{percentage}% complete</p>
                                </div>
                                <div className='px-3 mt-4 mb-2'>
                                    <p className='text-[10px] font-bold uppercase tracking-wider text-gray-400'>Chapters</p>
                                </div>
                                <Sidebar.Items>
                                    {jsonData && renderTopicsAndSubtopics(jsonData[mainTopic.toLowerCase()])}
                                </Sidebar.Items>
                                <div className='mt-4 mx-3'>
                                    <button onClick={redirectExam} className={`w-full flex items-center justify-between gap-2 px-3 py-3 rounded-lg border-2 transition-colors ${pass ? 'border-green-500 bg-green-50 dark:bg-green-900/20' : 'border-black dark:border-white hover:bg-gray-50 dark:hover:bg-gray-900'}`}>
                                        <div className='flex items-center gap-2'>
                                            <span className='text-lg'>🏆</span>
                                            <span className='text-sm font-bold text-black dark:text-white'>Final Quiz</span>
                                        </div>
                                        {pass ? <FaCheck className='text-green-600' size={14} /> : <span className='text-[10px] text-gray-400'>Locked at 100%</span>}
                                    </button>
                                </div>
                                <div className='mt-4 mx-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-900'>
                                    <p className='text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-2'>📖 How it works</p>
                                    <ul className='text-[11px] text-gray-600 dark:text-gray-400 space-y-1 leading-relaxed'>
                                        <li>• Click any chapter to expand</li>
                                        <li>• Click a lesson to generate content</li>
                                        <li>• Green check = lesson completed</li>
                                        <li>• Finish all lessons to unlock quiz</li>
                                        <li>• Pass quiz to earn certificate</li>
                                    </ul>
                                </div>
                            </Sidebar>
                            <div className='px-4 py-6 overflow-y-auto bg-gray-50 dark:bg-gray-950'>
                                <div className='bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden shadow-sm'>
                                    {type === 'video & text course' ? (
                                        <div className='w-full aspect-video bg-black'>
                                            <YouTube key={media} className='w-full h-full' iframeClassName='w-full h-full' videoId={media} opts={optsMobile} />
                                        </div>
                                    ) : (
                                        media && <img className='w-full h-48 object-cover' src={media} alt={selected} />
                                    )}
                                    <div className='p-5'>
                                        <p className='text-xs font-bold uppercase tracking-wider text-gray-400 mb-2'>Lesson</p>
                                        <h1 className='font-black text-black dark:text-white text-2xl mb-6 leading-tight'>{selected}</h1>
                                        <StyledText text={theory} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-row overflow-y-auto h-screen max-md:hidden'>
                        <Sidebar
                            theme={style}
                            aria-label="Default sidebar example">
                            <LogoComponent isDarkMode={storedTheme} />
                            <div className='mt-4 mb-3 px-3'>
                                <p className='text-[10px] font-bold uppercase tracking-wider text-gray-400 mb-2'>Course Progress</p>
                                <div className='h-1.5 w-full bg-gray-100 dark:bg-gray-900 rounded-full overflow-hidden'>
                                    <div className='h-full bg-gradient-to-r from-green-400 to-green-600 transition-all duration-500' style={{ width: `${percentage}%` }} />
                                </div>
                                <p className='text-xs font-bold text-black dark:text-white mt-1.5'>{percentage}% complete</p>
                            </div>
                            <div className='px-3 mt-4 mb-2'>
                                <p className='text-[10px] font-bold uppercase tracking-wider text-gray-400'>Chapters</p>
                            </div>
                            <Sidebar.Items>
                                {jsonData && renderTopicsAndSubtopics(jsonData[mainTopic.toLowerCase()])}
                            </Sidebar.Items>
                            <div className='mt-4 mx-3'>
                                <button onClick={redirectExam} className={`w-full flex items-center justify-between gap-2 px-3 py-3 rounded-lg border-2 transition-colors ${pass ? 'border-green-500 bg-green-50 dark:bg-green-900/20' : 'border-black dark:border-white hover:bg-gray-50 dark:hover:bg-gray-900'}`}>
                                    <div className='flex items-center gap-2'>
                                        <span className='text-lg'>🏆</span>
                                        <span className='text-sm font-bold text-black dark:text-white'>Final Quiz</span>
                                    </div>
                                    {pass ? <FaCheck className='text-green-600' size={14} /> : <span className='text-[10px] text-gray-400'>Locked at 100%</span>}
                                </button>
                            </div>
                            <div className='mt-4 mx-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-900'>
                                <p className='text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-2'>📖 How it works</p>
                                <ul className='text-[11px] text-gray-600 dark:text-gray-400 space-y-1 leading-relaxed'>
                                    <li>• Click any chapter to expand</li>
                                    <li>• Click a lesson to generate content</li>
                                    <li>• Green check = lesson completed</li>
                                    <li>• Finish all lessons to unlock quiz</li>
                                    <li>• Pass quiz to earn certificate</li>
                                </ul>
                            </div>
                        </Sidebar>
                        <div className='overflow-y-auto flex-grow flex-col'>
                            <Navbar fluid className='py-3 dark:bg-black bg-white border-black dark:border-white md:border-b'>
                                <Navbar.Brand className='ml-1'>
                                    {isComplete ?
                                        <p onClick={finish} className='mr-3 underline text-black dark:text-white font-normal'>Download Certificate</p> :
                                        <div className='w-8 h-8 mr-3'>
                                            <CircularProgressbar
                                                value={percentage}
                                                text={`${percentage}%`}
                                                styles={buildStyles({
                                                    rotation: 0.25,
                                                    strokeLinecap: 'butt',
                                                    textSize: '20px',
                                                    pathTransitionDuration: 0.5,
                                                    pathColor: storedTheme === "true" ? '#fff' : '#000',
                                                    textColor: storedTheme === "true" ? '#fff' : '#000',
                                                    trailColor: storedTheme === "true" ? 'grey' : '#d6d6d6',
                                                })}
                                            />
                                        </div>
                                    }
                                    <TruncatedText text={mainTopic} len={4} />
                                </Navbar.Brand>
                                <Navbar.Collapse>
                                    <div className='hidden md:flex justify-center items-center mb-2 mt-2'>
                                        <p onClick={redirectHome} className='font-normal text-black dark:text-white text-base mr-4'>Home</p>
                                        <p onClick={htmlDownload} className='font-normal text-black dark:text-white text-base mr-4'>Export</p>
                                        <ShareOnSocial
                                            textToShare={sessionStorage.getItem('mName') + " shared you course on " + mainTopic}
                                            link={websiteURL + buildCourseUrl(mainTopic, courseId)}
                                            linkTitle={sessionStorage.getItem('mName') + " shared you course on " + mainTopic}
                                            linkMetaDesc={sessionStorage.getItem('mName') + " shared you course on " + mainTopic}
                                            linkFavicon={logo}
                                            noReferer
                                        >
                                            <button
                                                type="button"
                                                className="bg-transparent"
                                            >
                                                <p className='font-normal text-black dark:text-white text-base mr-4'>Share</p>
                                            </button>
                                        </ShareOnSocial>
                                        <DarkModeToggle />
                                    </div>
                                </Navbar.Collapse>
                            </Navbar>
                            <div className='px-8 py-8 bg-gray-50 dark:bg-gray-950 min-h-full'>
                                <div className='max-w-4xl mx-auto'>
                                    <div className='bg-white dark:bg-black rounded-2xl border border-gray-200 dark:border-gray-800 overflow-hidden shadow-sm'>
                                        {type === 'video & text course' ? (
                                            <div className='w-full aspect-video bg-black'>
                                                <YouTube key={media} className='w-full h-full' iframeClassName='w-full h-full' videoId={media} opts={opts} />
                                            </div>
                                        ) : (
                                            media && (
                                                <div className='relative w-full h-72 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-900 dark:to-gray-800'>
                                                    <img className='w-full h-full object-cover' src={media} alt={selected} />
                                                </div>
                                            )
                                        )}
                                        <div className='p-10'>
                                            <p className='text-xs font-bold uppercase tracking-wider text-gray-400 mb-3'>Lesson</p>
                                            <h1 className='font-black text-black dark:text-white text-3xl mb-8 leading-tight'>{selected}</h1>
                                            <div className='h-px bg-gray-200 dark:bg-gray-800 mb-8' />
                                            <StyledText text={theory} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col'>
                        <ChatWidget defaultMessage={defaultMessage} defaultPrompt={defaultPrompt} mainTopic={mainTopic} />
                        <NotesWidget courseId={courseId} mainTopic={mainTopic} />
                    </div>
                </div>
            }
        </>
    );
};


export default Course;